import { Loadable } from '../../components/common/loadable/loadable';

export const LoginContainer = Loadable<any>({
  loader: () =>
    import(/* webpackChunkName: "login" */ './login').then(
      (module) => module.LoginContainer,
    ),
});
